<div class="alert alert-danger">
    <fa-icon [icon]="faWarning" size="2x" class="me-2"></fa-icon>
    You must fill every field for all the ingredients
</div>